import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanListPageUI from './LoanListPageUI.js'

class LoanListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loanList: null,
      response: null
    }
  }

  render() {
    return (
      <LoanListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loanList={this.state.loanList}
        response={this.state.response}
        onRefreshClick={this.onRefreshClick}
        onTypeChange={this.onTypeChange}
        openOrClosed={'open'}
        pageTitle={'Underwriting'}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    const queryParameters = new URLSearchParams(window.location.search)
    this.getLoans(context, context.filter)
  }

  onTypeChange = (type) => {
    this.getLoans(this.props.context, type)
  }

  getLoans(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans`,
      cacheKey: CacheKeys.AllLoans('open', stp),
      callback: this.getLoansCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context, {}, { openOrClosed: 'open', stp: stp === 'stp' ? true : false })
  }

  getLoansCallback = (response) => {
    this.setState({ errorList: response.errorList, loanList: response.loanList, response: response })
  }

  onRefreshClick = () => {
    /*
    this.state.loanList.forEach(loan => {
      CacheManager.removeObject(CacheKeys.BillsByLoanId(loan.loanId))
      CacheManager.removeObject(CacheKeys.Orders(loan.loanId, ''))
      if (loan.termSheet)
        CacheManager.removeObject(CacheKeys.Order(loan.termSheet.estimateId))
    })
    */
    CacheManager.removeObject(CacheKeys.AllLoans('open', this.props.context.filter))
    this.setState({ loanList: null, errorList: null })
    this.getLoans(this.props.context, this.props.context.filter)
  }
}

export default withRouter(LoanListPageSF)
